import { render, staticRenderFns } from "./poolImort.vue?vue&type=template&id=2c72cd7f&scoped=true&"
import script from "./poolImort.vue?vue&type=script&lang=js&"
export * from "./poolImort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72cd7f",
  null
  
)

export default component.exports